import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';
import { defineStore } from 'pinia';
import type { FetchRecipeResponse } from '~/types/api/recipes';
import type { FullRecipe } from '~/types/typings';

// Хранилище нужно, чтобы передавать рецепт из middleware на страницу,
// потому что рецепт необходимо запрашивать именно в middleware, чтобы
// виджеты отрисовывались внутри layout

export const useRecipeStore = wrapPiniaStore(
  defineStore('recipe', () => {
    const recipeData = ref<FetchRecipeResponse>();
    const recipe = computed<FullRecipe>(() => recipeData.value?.item);

    function setRecipeData(payload: FetchRecipeResponse) {
      recipeData.value = payload;
    }

    return { recipe, recipeData, setRecipeData };
  }),
);
